import axios from "axios"

export interface OrderItemDetail {
  id: number
  image?: string
  name: string
  productId?: number
  productPermalink?: string
  quantity: number
  sku?: string
  subtotal: number
  total: number
  variationAttributes?: Array<{
    name: string
    value: string
  }>
}

export interface OrderNote {
  content: string
  date: string
  id: number
}

export interface OrderAddress {
  address1: string
  address2?: string
  city: string
  company?: string
  country: string
  email?: string
  firstName: string
  lastName: string
  phone?: string
  postcode: string
  state: string
}

export interface OrderTotalLine {
  label: string
  value: string
}

export interface AccountOrderDetail {
  billingAddress: OrderAddress
  currency: string
  customerNote?: string
  dateCreated: string
  id: number
  items: OrderItemDetail[]
  needsShipping: boolean
  number: string
  orderNotes: OrderNote[]
  shippingAddress?: OrderAddress
  status: string
  totals: OrderTotalLine[]
}

export interface AccountOrderDetailResponse {
  code?: string
  message?: string
  ok: boolean
  order?: AccountOrderDetail
}

export const getAccountOrderDetail = async (
  orderNumber: string
): Promise<AccountOrderDetailResponse> => {
  const { data } = await axios.get<AccountOrderDetailResponse>(
    `/api/account/orders/${orderNumber}`
  )

  return data
}
